import { Box } from "@mui/material";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { RewardsWithPopup } from "Components/Layout/UserHeader/RewardsWithPopup";
import { NotificationWithPopover } from "Components/Layout/UserHeader/Notifications/NotificationWithPopover";
import { AvatarWithPopup } from "Components/Layout/UserHeader/AvatarWithPopup";
import { useHasBackgroundImage } from "Hooks/Layout/useHasBackgroundImage";
import { useIsLoyaltyPointsVisible } from "Hooks/useIsLoyaltyPointsVisible";
import { useLoyaltiesOverviewQuery } from "Api/Queries/Loyalty/useLoyaltiesOverviewQuery";
import { LoyaltyPointsLink } from "Components/Loyalty/LoyaltyPointsLink";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { Resources, useResource } from "Translations/Resources";

export const UserHeader = () => {
  const user = useLoggedInUser();
  const { hasBackgroundImage } = useHasBackgroundImage();
  const isLoyaltyPointsVisible = useIsLoyaltyPointsVisible();
  // A region-less user would get a RegionRequired 403 on every page load — hold the query until
  // they confirm a region; the refreshed user-info flag re-enables it (same gate as
  // useSyncAccountsWhenRegionReady).
  const isRegionRequired = user?.regionRequired ?? false;
  const { data, isLoading } = useLoyaltiesOverviewQuery({
    enabled: isLoyaltyPointsVisible && !isRegionRequired,
  });
  const isHunter = useIsCurrentUserHunter();
  const { t } = useResource();

  if (!user) {
    return null;
  }

  // The dark variant is white-on-translucent and readable only over the dashboard image; the plain
  // page (desktop menu, staff-role mobile dashboard) needs the light one.
  const colorVariant = hasBackgroundImage ? "dark" : "light";

  return (
    <Box
      display="flex"
      gap={2}
      width="100%"
      alignItems="center"
      justifyContent={["space-between", "space-between", "flex-start"]}
    >
      <Box display="flex" gap={2} alignItems="center">
        <AvatarWithPopup />
        {isLoyaltyPointsVisible && (
          <>
            <LoyaltyPointsLink colorVariant={colorVariant} />
            <RewardsWithPopup
              colorVariant={colorVariant}
              totalRewards={data?.poolTotal.value ?? 0}
              currencyCode={data?.poolTotal.currencyCode}
              totalPoints={data?.totalPoints.points ?? 0}
              totalPointsLabel={t(
                isHunter
                  ? Resources.UserMenu.Rewards.TotalValor
                  : Resources.UserMenu.Rewards.TotalStardust,
              )}
              myShare={data?.userShare.value ?? 0}
            />
          </>
        )}
      </Box>
      <NotificationWithPopover colorVariant={colorVariant} />
    </Box>
  );
};
